import { Mutation as ApolloMutation } from 'react-apollo';

export default ApolloMutation;
